// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__1Svp4","amount":"Amount_amount__227X_","tip":"Amount_tip__bpQ5z","tipHeader":"Amount_tipHeader__1Ld3j","tipsWrap":"Amount_tipsWrap__3fDF3"};